<template>
  <div class="direction">
    <img src="../../assets/Main/SubSection/direction.png">
  </div>
</template>
<script>
export default {
  name: "Direction",
  methods: {
    onDisplayed() {}
  }
};
</script>

<style lang="scss" scoped>
.direction {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.4));
}

.centering {
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/Parts/Direction.vue